module.exports = __webpack_public_path__ + "static/media/ig.526cf00a.jpg";